import './scripts/review-forest';
import './scripts/neocom';
import './scripts/trusted';
import './plugins/payone';
import './plugins/view-360';

const PluginManager = window.PluginManager;

PluginManager.register(
    'RegisterTogglePlugin',
    () => import('./plugins/register-toggle.plugin'),
    '[data-register-toggle]',
);
PluginManager.register('SearchTogglePlugin', () => import('./plugins/search-toggle.plugin'), '[data-search-toggle]');
PluginManager.register(
    'ProductVariantsSlider',
    () => import('./plugins/product-variants-slider.plugin'),
    '[data-variant-slider]',
);
PluginManager.register('ShowMore', () => import('./plugins/show-more.plugin'), '#more');
PluginManager.register('ZoomModalActions', () => import('./plugins/zoom-modal-actions.plugin'));
PluginManager.register('PostFilterPlugin', () => import('./plugins/post-filter.plugin'), '[data-post-filter]');
PluginManager.register(
    'CbkGalleryThumbnailsSlider',
    () => import('./plugins/gallery-thumbnails-slider.plugin'),
    '[data-gallery-thumbnails-slider]',
);
PluginManager.register('AddToOfferPlugin', () => import('./plugins/add-to-offer.plugin'), '[data-add-to-offer]');
// PluginManager.register('OfferPreviewPlugin', () => import('./plugins/offer-preview.plugin'), '[data-offer-preview]');
PluginManager.register('OfferCreatePlugin', () => import('./plugins/offer-create.plugin'), '[data-offer-create]');
PluginManager.register('OfferConfirmPlugin', () => import('./plugins/offer-confirm.plugin'), '[data-offer-confirm]');
PluginManager.register('CheckboxMessagePlugin', () => import('./plugins/checkbox-message.plugin'));
PluginManager.register('MediaGridPlugin', () => import('./plugins/media-grid.plugin'), '.media-grid-container');
PluginManager.register(
    'ReferenceSliderConfigPlugin',
    () => import('./plugins/reference-slider-config.plugin'),
    '.reference-slider',
);
PluginManager.register(
    'OffCanvasContentPlugin',
    () => import('./plugins/offcanvas-content.plugin'),
    '[data-offcanvas-content]',
);
PluginManager.register(
    'OffCanvasTrustedShopsBadgePlugin',
    () => import('./plugins/offcanvas-trusted-shops-badge.plugin'),
);
PluginManager.register(
    'SpeculationRulesPlugin',
    () => import('./plugins/speculation-rules.plugin'),
    '[data-speculation-rules]',
);
PluginManager.register('PaginationStylePlugin', () => import('./plugins/pagination-style.plugin'), '[data-show-more]');
PluginManager.register(
    'OtherVariantsModalPlugin',
    () => import('./plugins/other-variants-modal.plugin'),
    '.other-variants-modal',
);
PluginManager.register(
    'VariantAnalyticsPlugin',
    () => import('./plugins/variant-analytics.plugin'),
    '[data-variant-analytics]',
);
PluginManager.register(
    'emailInputValidatorPlugin',
    () => import('./plugins/email-input-validator.plugin'),
    '.register-submit button',
);
PluginManager.register('bannerPlugin', () => import('./plugins/banner.plugin'), '.banner-close');
PluginManager.register(
    'DeliveryDatePlugin',
    () => import('./plugins/delivery-date.plugin'),
    '[data-delivery-date-calculator]',
);
PluginManager.register(
    'DeliveryDateAsidePlugin',
    () => import('./plugins/delivery-date-aside.plugin'),
    '[data-delivery-date-aside]',
);
PluginManager.register(
    'CobShareBasketPlugin',
    () => import('./plugins/share-basket.plugin'),
    '[data-cob-share-basket]',
);

PluginManager.override('OffCanvasMenu', () => import('./plugins/offcanvas-menu.plugin'), '[data-off-canvas-menu]');
PluginManager.override(
    'ListingPagination',
    () => import('./plugins/listing-pagination.plugin'),
    '[data-listing-pagination]',
);
PluginManager.override('Listing', () => import('./plugins/listing.plugin'), '[data-listing]');
PluginManager.override('FlyoutMenu', () => import('./plugins/flyout-menu.plugin'), '[data-flyout-menu]');
PluginManager.override('ListingSorting', () => import('./plugins/listing-sorting.plugin'), '[data-listing-sorting]');
PluginManager.override(
    'OffCanvasFilter',
    () => import('./plugins/offcanvas-filter.plugin'),
    '[data-off-canvas-filter]',
);
PluginManager.override('Magnifier', () => import('./plugins/magnifier.plugin'), '[data-magnifier]');
PluginManager.override('ZoomModal', () => import('./plugins/zoom-modal.plugin'), '[data-zoom-modal]');
PluginManager.register('StickyHeaderPlugin', () => import('./plugins/sticky-header.plugin'));
PluginManager.register(
    'ProductDetailStickyPlugin',
    () => import('./plugins/product-detail-sticky.plugin'),
    '.product-detail-main',
);
PluginManager.register(
    'HubSpotFaqFormPlugin',
    () => import('./plugins/hubspot-faq-form.plugin'),
    '[data-hubspot-faq-form]',
);
PluginManager.register(
    'FaqMarkdownLinksPlugin',
    () => import('./plugins/faq-markdown-links.plugin'),
    '[data-faq-markdown-links]',
);

if (window.wishlistEnabled) {
    if (!window.customerLoggedInState) {
        PluginManager.override(
            'WishlistStorage',
            () => import('./plugins/local-wishlist.plugin'),
            '[data-wishlist-storage]',
        );
    }

    PluginManager.override(
        'WishlistWidget',
        () => import('./plugins/wishlist-widget.plugin'),
        '[data-wishlist-widget]',
    );
    PluginManager.override('AddToWishlist', () => import('./plugins/add-to-wishlist.plugin'), '[data-add-to-wishlist]');
}

(function () {
    'use strict';

    function checkItemsWidth() {
        const filterPanelItems = document.querySelectorAll('.filter-panel-item');
        if (filterPanelItems.length) {
            filterPanelItems.forEach((item) => (item.style.display = 'block'));
            const firstOffsetTop = filterPanelItems[0].getBoundingClientRect().top;
            filterPanelItems.forEach((item) => {
                if (item.getBoundingClientRect().top > firstOffsetTop) {
                    item.style.display = 'none';
                } else {
                    item.style.display = 'block';
                }
            });
            document.querySelector('.filter-panel-items-container-wrapper-inner').style.overflow = 'visible';
        }
    }

    window.addEventListener(
        'resize',
        () => {
            checkItemsWidth();
        },
        { passive: true },
    );

    window.addEventListener(
        'load',
        () => {
            checkItemsWidth();
        },
        { passive: true },
    );

    window.checkItemsWidth = checkItemsWidth;

    document.querySelectorAll('.cms-category-image').forEach((element) => {
        element.addEventListener('click', (e) => {
            e.preventDefault();

            const url = element.querySelector('a').getAttribute('href');

            if (url) {
                const target = element.querySelector('a').getAttribute('target');

                if (target === '_blank') {
                    window.open(url);
                } else {
                    window.location.href = url;
                }
            }
            return false;
        });
        element.style.cursor = 'pointer';
    });

    // Product Filter - going JS way as pure CSS sticky bugs due to parent flex box and overflow elements
    var ProductFilter = {
        element: null,
        container: null,
        offsetTop: 0,
        sticky: false,
        init: function () {
            this.element = document.querySelector('.filter-panel-items-container-wrapper');
            this.container = document.querySelector('.filter-panel-items-container-wrapper-inner');
            this.updateFilterHighlight();
            ProductFilter.offsetTop = window.pageYOffset + ProductFilter.element.getBoundingClientRect().top;

            document.querySelector('.remove-filter-sticky').addEventListener(
                'click',
                () => {
                    document.querySelector('.sticky-filter').classList.remove('sticky-filter');
                },
                { passive: true },
            );

            document.querySelectorAll('.filter-panel-items-container input').forEach((filterInput) => {
                filterInput.addEventListener(
                    'change',
                    (e) => {
                        ProductFilter.hightlightActiveFilter(e.currentTarget.closest('.filter-panel-item'));
                    },
                    { passive: true },
                );
            });

            document.querySelector('.filter-panel-active-container').addEventListener(
                'click',
                (e) => {
                    if (e.target.classList.contains('filter-active-remove')) {
                        const effectedFilter = document.getElementById(e.target.dataset.id);
                        ProductFilter.hightlightActiveFilter(effectedFilter.closest('.filter-panel-item'));
                    }
                },
                { passive: true },
            );
        },
        /*        observeSticky: function () {
            if (window.pageYOffset > ProductFilter.offsetTop) {
                if (ProductFilter.sticky === false) {
                    ProductFilter.element.classList.add('sticky-filter');
                    ProductFilter.container.classList.add('container');
                    ProductFilter.sticky = true;
                }
            } else {
                if (ProductFilter.sticky === true) {
                    ProductFilter.element.classList.remove('sticky-filter');
                    ProductFilter.container.classList.remove('container');
                    ProductFilter.sticky = false;
                }
            }
        },*/
        updateFilterHighlight: function () {
            document.querySelectorAll('.filter-panel-item').forEach(function (filterEl) {
                ProductFilter.hightlightActiveFilter(filterEl);
            });
        },
        hightlightActiveFilter: function (filterEl) {
            if (filterEl.classList.contains('filter-range')) {
                // filter range check
                if (ProductFilter.isFilterRangeSet(filterEl)) {
                    filterEl.classList.add('filter-selected');
                } else {
                    filterEl.classList.remove('filter-selected');
                }
            } else {
                // multi select check
                if (filterEl.querySelector('input:checked')) {
                    filterEl.classList.add('filter-selected');
                } else {
                    filterEl.classList.remove('filter-selected');
                }
            }
        },
        isFilterRangeSet: function (filterEl) {
            var hasActiveFilterValue = false;
            filterEl.querySelectorAll('input').forEach(function (filterInput) {
                if (filterInput.value !== '') {
                    hasActiveFilterValue = true;
                }
            });
            return hasActiveFilterValue;
        },
    };
    var TagManagerAdditionalfeatures = {
        init: function () {
            this.handlePromoProducts();
            this.handleProductImageLinkClicks();
        },
        handlePromoProducts: function () {
            // track similar and matching articles, if loaded
            const types = ['similar', 'matching'];

            var sids = [];

            for (var i = 0; i < types.length; i++) {
                let type = types[i];
                let similarProducts = document.querySelector('.product-detail-' + type + '-products');

                if (similarProducts) {
                    let cnt = 1;

                    document
                        .querySelectorAll('.product-detail-' + type + '-products .product-slider-item')
                        .forEach(function (item) {
                            let title = item.querySelector('.product-box-product-name').innerHTML.trim();
                            let sku = item.querySelector("meta[itemprop='sku']")?.getAttribute('content');
                            let position = 'slot' + String(cnt);

                            sids.push({ id: sku, name: title, creative: type + '_articles', position: position });
                            cnt++;

                            let productImg = item.querySelector('.product-image-link');
                            productImg.addEventListener('click', function (_e) {
                                window.dataLayer.push({
                                    event: 'promotionClick',
                                    ecommerce: {
                                        promoClick: {
                                            promotions: [
                                                {
                                                    id: sku, // Name or ID is required.
                                                    name: title,
                                                    creative: type + '_articles',
                                                    position: position,
                                                },
                                            ],
                                        },
                                    },
                                });
                            });
                        });
                }
            }
            if (sids.length > 0) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: { promoView: { promotions: sids } } });
            }
        },
        handleProductImageLinkClicks: function () {
            window.dataLayer = window.dataLayer || [];
            document.querySelectorAll('.product-image-link').forEach(function (element) {
                element.addEventListener('click', function (e) {
                    var title = element.getAttribute('title');
                    window.dataLayer.push({
                        ecommerce: { click: { promotions: title } },
                    });
                });
            });
        },
    };

    // we need to wait until images have been loaded in order to get the correct offsetTop value
    window.addEventListener(
        'load',
        (event) => {
            if (document.querySelector('.filter-panel-items-container')) {
                ProductFilter.init();
                window._ProductFilter = ProductFilter;
            }
            TagManagerAdditionalfeatures.init();
            // Newsletter
            const newsletterForm = document.querySelector('#newsletter-subscription-form');
            if (newsletterForm) {
                const newsletterSubmitPlugin = PluginManager.getPluginInstanceFromElement(
                    newsletterForm,
                    'FormAjaxSubmit',
                );
                if (typeof newsletterSubmitPlugin !== 'undefined') {
                    newsletterSubmitPlugin.$emitter.subscribe('onAfterAjaxSubmit', () => {
                        newsletterForm.querySelector('.form-text').remove();
                        newsletterForm.querySelector('.form-row.g-2.mx-0').remove();
                        newsletterForm.querySelector('.newsletter-success').style.display = 'block';
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({ event: 'formSubmission', formType: 'nl_footer' });
                    });
                }
            }
            // Job application via Sage
            const url = document.location.href;
            if (url.indexOf('stellenangebote') !== -1) {
                // We "hijack" the form by MoorlFormBuilder!
                // It will render the form, but we change the target.
                const jobForm = document.querySelector('.storyblok-cms form');
                if (jobForm) {
                    // endpoint see plugin CobSageJobs
                    jobForm.setAttribute('action', '/jobapp');

                    // take the jobname automatically from headline
                    const jobTitle = document.querySelector('.storyblok-cms h2').innerHTML;
                    jobForm.querySelector('input[name="position"]').setAttribute('value', jobTitle);
                }
            }
        },
        { passive: true },
    );
})(PluginManager);

PluginManager.initializePlugins().then(async () => {
    await waitForPlugin('B2B_AjaxPanelPlugin');

    for (const instance of PluginManager.getPluginInstances('B2B_AjaxPanelPlugin')) {
        instance.$emitter.subscribe('b2b--ajax-panel_loaded', () => {
            PluginManager.initializePlugins();
        });
    }
});

async function waitForPlugin(pluginName) {
    return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
            const list = Object.keys(PluginManager.getPluginList());
            if (list.includes(pluginName)) {
                clearInterval(checkInterval);
                resolve();
            }
        }, 100);
    });
}
//add redirect parameter to language widget
document.addEventListener('DOMContentLoaded', function () {
    function updateMobileBreadcrumbs() {
        const isMobile = window.matchMedia('(max-width: 767.99px)').matches;

        document.querySelectorAll('ol.breadcrumb').forEach((breadcrumb) => {
            const items = Array.from(breadcrumb.querySelectorAll(':scope > .breadcrumb-item'));
            const existingEllipsis = breadcrumb.querySelector(':scope > .breadcrumb-mobile-ellipsis');

            if (existingEllipsis) {
                existingEllipsis.remove();
            }

            Array.from(breadcrumb.children).forEach((child) => {
                child.classList.remove('breadcrumb-mobile-hidden');
            });

            if (!isMobile || breadcrumb.dataset.mobileBreadcrumbExpanded === 'true' || items.length <= 2) {
                return;
            }

            const firstVisibleItem = items[items.length - 2];
            const children = Array.from(breadcrumb.children);
            const firstVisibleIndex = children.indexOf(firstVisibleItem);

            children.forEach((child, index) => {
                if (index < firstVisibleIndex - 1) {
                    child.classList.add('breadcrumb-mobile-hidden');
                }
            });

            const ellipsisItem = document.createElement('li');
            ellipsisItem.className = 'breadcrumb-item breadcrumb-mobile-ellipsis';

            const ellipsisButton = document.createElement('button');
            ellipsisButton.type = 'button';
            ellipsisButton.className = 'breadcrumb-mobile-ellipsis-button';
            ellipsisButton.textContent = '...';
            ellipsisButton.setAttribute('aria-label', 'Show full breadcrumb');
            ellipsisButton.addEventListener('click', () => {
                breadcrumb.dataset.mobileBreadcrumbExpanded = 'true';
                updateMobileBreadcrumbs();
            });

            ellipsisItem.appendChild(ellipsisButton);

            const insertBeforeNode = children[firstVisibleIndex - 1] || children[firstVisibleIndex];
            if (insertBeforeNode) {
                breadcrumb.insertBefore(ellipsisItem, insertBeforeNode);
            }
        });
    }

    updateMobileBreadcrumbs();
    window.addEventListener('resize', updateMobileBreadcrumbs, { passive: true });

    const params = new URLSearchParams(window.location.search);
    let languageFormElement = document.querySelector('#redirectByLanguage');

    if (languageFormElement) {
        params.forEach((value, key) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `redirectParameters[${key}]`;
            input.value = value;

            document.querySelector('#redirectByLanguage')?.appendChild(input);
        });
    }
});
